import React, { useState, useEffect, useRef  } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Splash from '../../../splash/Splash';

const sections = [
    { title: "HOT", icon: "icon-home.png", type: "HOT" },
    { title: "Sports", icon: "icon-sport.png", type: "SPORTS" },
    { title: "Casino", icon: "icon-casino.png", type: "LIVE" },
    { title: "Slot", icon: "icon-slot.png", type: "SLOT" },
    { title: "Crash", icon: "icon-crash.png", type: "EGAME" },
    { title: "Table", icon: "icon-table.png", type: "TABLE" },
    { title: "Fishing", icon: "icon-fish.png", type: "FH" },
    { title: "Poker", icon: "icon-arcade.png", type: "BINGO" },

    
];



const defaultSportsOptions = [
    { name: "9wickets", icon: "9wickets.png", link: "/exchange" },
    { name: "Velki", icon: "velki.png", link: "/velki" },
    { name: "SABA", icon: "saba.png", code: "08ced9dd788aed11ff3c7f387ae0f063", type: "Sports Game", platform: 'SABASports(IBC)' },
    { name: "United Gaming", icon: "ug.jpg", code: "c4b2813f6bbc5abf502ddfb857e604eb", type: "Sports Game", platform: 'UnitedGaming' },
    { name: "LuckSports", icon: "luckysports.svg", code: "92b24e4c25107367a80e0fe1a97c24e4", type: "Sports Game", platform: 'LuckySport' },
    { name: "TF", icon: "tf.png", code: "4ee8e0051a035b463b47c3c473ce317d", type: "Esports", platform: 'TF' },
    { name: "Bti", icon: "bti.png", code: "4d31f1186a81e208c003a7e37411ce35", type: "Sports Game", platform: 'bti' },
    { name: "DPE", icon: "dp.png", code: "e130116fdc9bcde2dbb31735b6c365d6", type: "Esports", platform: 'DPEsports' },
    { name: "DP", icon: "dp.png", code: "23c2dca76f87d7b7f239833060c8751e", type: "Sports Game", platform: 'DPSports' },
    { name: "SBO(VS)", icon: "sbobet.png", code: "341827d4370bb198b18364e2d75e6916", type: "VirtualSports", platform: 'SBO' },
    { name: "SBO", icon: "sbo.png", code: "07baf9e1388d32cd4cee0c0c91b23020", type: "Sports Game", platform: 'SBO' },
    { name: "CMD", icon: "cmd.png", code: "1f7fbf84bf1bcc08c3a7ea27db75f366", type: "Sports", platform: 'CMD' },
    { name: "IA", icon: "ia.png", code: "68ddcab094a2375b08ca63eb33ef8673", type: "ESports", platform: 'IA' },
];

const GameNavIcon = ({ marketBlock, featuredGames = [] }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [systems, setSystems] = useState([]);
    const [providers, setProviders] = useState([]);
    const [sportsOptions, setSportsOptions] = useState(defaultSportsOptions);
    const [error, setError] = useState(null);
    const [contentPosition, setContentPosition] = useState("0px");
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [isLoggedIn] = useState(!!localStorage.getItem('token')); 
    const origin = window.location.origin;
    const isMobile = typeof window !== 'undefined'
        ? (window.innerWidth <= 768 || /Mobi|Android/i.test(window.navigator.userAgent))
        : false;
    // new state for market block modal
    const [showBlockedModal, setShowBlockedModal] = useState(false);
    const [blockedSection, setBlockedSection] = useState('');


    useEffect(() => {
        const fetchSportsList = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/sports-list`);
                if (response.ok) {
                    const data = await response.json();
                    if (Array.isArray(data) && data.length > 0) {
                        setSportsOptions(data);
                    }
                }
            } catch (err) {
                // keep defaults on error
            }
        };
        fetchSportsList();
    }, []);

    useEffect(() => {
        const selectedSection = sections[activeIndex];
        if (selectedSection.type && selectedSection.type !== "SPORTS" && selectedSection.type !== "HOT") {
            fetchSystems(selectedSection.type);
        } else {
            setSystems([]);
            setProviders([]);
        }
    }, [activeIndex]);
    //  new function to handle casino click
    const handleCasinoClick = (system, type, title) => {
        if (marketBlock?.cs_market === 0) {
        setBlockedSection('Games');
        setShowBlockedModal(true);
        return;
    }
        navigate(`/games?type=${type}&system=${system}&title=${title}`);
    };

    const handleSectionClick = (index) => {
        setActiveIndex(index);
        setContentPosition("-100%");
        setTimeout(() => setContentPosition("0px"), 500);
    };

    const fetchSystems = async (type) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get-system?type=${type}`);
            const data = await response.json();
            if (response.ok) {
                setSystems(data.systems || []);
                fetchProviders(data.systems);
            } else {
                setError(data.message || 'Failed to fetch systems');
            }
        } catch (error) {
            console.error('Error fetching systems:', error);
            setError('An unexpected error occurred while fetching systems');
        }
    };
    // new function to handle game click
    const handleGameClick = async (gameCode, gamePlatform, gameType) => {
        if (marketBlock?.exchange_market === 0 && marketBlock?.status !== 'active') {
        setBlockedSection('Sports');
        setShowBlockedModal(true);
        return;
        }
        if (!isLoggedIn) {
            navigate('/login');
            return;
        }
    
        const token = localStorage.getItem('token');
        const remote_id = localStorage.getItem('remote_id');
    
        if (!token || !remote_id) {
            setError('User not logged in');
            return;
        }
    
        setIsLoading(true);
    
        try {
            // Direct URL support (for hot/featured games that already have a launch URL)
            if (typeof gameCode === 'string' && /^https?:\/\//i.test(gameCode)) {
                navigate('/gamerun', { state: { iframeUrl: gameCode } });
                return;
            }

            // Allow calling with only gameCode by parsing platform and type from the code if needed
            if ((!gamePlatform || !gameType) && typeof gameCode === 'string' && gameCode.includes('-')) {
                const parts = gameCode.split('-');
                if (parts.length >= 2) {
                    gamePlatform = parts[0];
                    gameType = parts[1];
                }
            }
            if (gamePlatform === 'Lucky' || gamePlatform === 'LuckySpodddrt') {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/player-login`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({ user_id: remote_id }),
                });

                const dataly = await response.json();
                if (dataly?.access_token) {
                    navigate('/gamerun', {
                        state: { iframeUrl: `https://sprodm.uni247.xyz/?access_token=${dataly.access_token}` },
                    });
                    return; 
                }
            }
    
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inr-game-run`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    userId: remote_id,
                    externalURL: origin,
                    isMobileLogin: isMobile,
                    gameCode: gameCode,
                    gameType: gameType,
                    platform: gamePlatform,
                }),
            });
    
            const data = await response.json();
    
            if (response.ok) {
                const iframeUrl = data?.url || data?.data?.payload?.game_launch_url;
                if (iframeUrl) {
                    navigate('/gamerun', { state: { iframeUrl } });
                } else {
                    setError(data.message || 'An unexpected error occurred');
                } 
            } else {
                setError(data.message || 'An unexpected error occurred');
            }
        } catch (error) {
            console.error('Error launching game:', error);
            setError('An unexpected error occurred');
        } finally {
            setIsLoading(false);
        }
    };
    
  

    const fetchProviders = async (systems) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get-provider?system=${JSON.stringify(systems)}`);
            const data = await response.json();
            if (response.ok) {
                const providerData = data.data || [];
                const sorted = providerData.sort((a, b) => {
                    const indexA = systems.indexOf(a.platform);
                    const indexB = systems.indexOf(b.platform);
                    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
                });
                setProviders(sorted);
            } else {
                setError(data.message || 'Failed to fetch providers');
            }
        } catch (error) {
            console.error('Error fetching providers:', error);
            setError('An unexpected error occurred while fetching providers');
        }
    };
    const navRef = useRef(null);
    useEffect(() => {
        const navElement = navRef.current;
    
        // Default: remove 'active' on first load
        if (navElement) {
            navElement.classList.remove('active');
        }
    
        const handleScroll = () => {
            const currentScrollPos = window.pageYOffset;
    
            if (!navElement) return;
    
            if (currentScrollPos > 300) {
                navElement.classList.add('active');
            } else {
                navElement.classList.remove('active');
            }
        };
    
        window.addEventListener('scroll', handleScroll);
    
        // Cleanup
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
   // new function to handle exchange click
    const handleExchangeClick = () => {
    if (marketBlock?.exchange_market === 0 && marketBlock?.status !== 'active') {
      setBlockedSection('Exchange');
      setShowBlockedModal(true);
      return;
    }
    navigate('/exchange');
  };
    if(isLoading) {
        return(
        <Splash/>
        );
      }
    

    return (
        <div className="mcd-game-nav-icon-inner">
            <div ref={navRef} id="nav" className="nav nav-category nav-auto active">
                {sections.map((section, index) => (
                    <div
                        key={index}
                        className={`btn ${activeIndex === index ? 'selected' : ''}`}
                        onClick={() => handleSectionClick(index)}
                    >
                        <div className="icon">
                            <span
                                className="item-icon"
                                style={{
                                    backgroundImage: `url(https://img.b4711gb.com/bgb/h5/assets/images/icon-set/theme-icon/${section.icon}?v=1729676340443)`
                                }}
                            ></span>
                        </div>
                        <p>{section.title}</p>
                    </div>
                ))}
            </div>
            <div className="nav-wrap">
                <div id="nav-title" className="content-title">
                    <h2>
                        <span>{sections[activeIndex].title}</span>
                    </h2>
                </div>
                <div className="nav-content-wrap">
                    <div
                        className="nav-content-inner"
                        style={{
                            transform: `translateX(${contentPosition})`,
                            transition: "transform 0.5s ease"
                        }}
                    >
                        <div className="content-box">
                            <div className="layout-brand">
                                <div className="card1">
                                    {sections[activeIndex].type === "SPORTS" ? (
                                        <ul>
                                            {sportsOptions.map((sport, index) => (
                                                <li key={index}>
                                                {sport.link  ? (
                                                    <a onClick={sport.link === '/exchange' ? handleExchangeClick : () => navigate(sport.link)}
                                                       >
                                                        <div
                                                            className="icon-sport"
                                                            style={{
                                                                backgroundImage: `url(${process.env.REACT_APP_API_URL}/icon/${sport.icon})`,
                                                                backgroundSize: 'contain',
                                                                backgroundRepeat: 'no-repeat',
                                                                backgroundPosition: 'center',
                                                                WebkitMaskImage: 'none',
                                                                maskImage: 'none'
                                                            }}
                                                        ></div>
                                                        <p>{sport.name}</p>
                                                    </a>
                                                ) : (
                                                    <a>
                                                <div
                                                    onClick={sport.code && sport.platform && sport.type ? () => handleGameClick(sport.code, sport.platform, sport.type) : null}

                                                        style={{
                                                            cursor: sport.code ? 'pointer' : 'default'
                                                        }}
                                                    >
                                                        <div
                                                            className="icon-sport"
                                                            style={{
                                                                backgroundImage: `url(${process.env.REACT_APP_API_URL}/icon/${sport.icon})`,
                                                                backgroundSize: 'contain',
                                                                backgroundRepeat: 'no-repeat',
                                                                backgroundPosition: 'center',
                                                                WebkitMaskImage: 'none',
                                                                maskImage: 'none'
                                                            }}
                                                        ></div>
                                                        <p>{sport.name}</p>
                                                    </div>
                                                </a>
                                                )}
                                            </li>
                                            
                                            ))}
                                        </ul>
                                    ) : sections[activeIndex].type === "HOT" ? (
                                        <div className="recommend feature-games mobile-hot-grid">
                                            <div className="recommend-title">
                                            </div>
                                            <div className="recommend-bg games">
                                                <div className="recommend-main games-main">
                                                    {featuredGames && featuredGames.length > 0 ? (
                                                        featuredGames.map((game, index) => (
                                                            <div onClick={() => handleGameClick(game.link)} className="games-box hot-card" key={index}>
                                                                <span className="corner-fold" />
                                                                <div className="pic">
                                                                    <a>
                                                                        <img 
                                                                            alt={game.name} 
                                                                            src={`${process.env.REACT_APP_API_URL}/storage/${game.thubmnail}`} 
                                                                            loading="lazy" 
                                                                        />
                                                                    </a>
                                                                </div>
                                                                <div className="text">
                                                                    <h3>{game.name}</h3>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <p></p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <ul>
                                            {providers.length > 0 ? (
                                                providers.map((provider, index) => (
                                                    <li key={index}>
                                                        <a href='#' onClick={() => handleCasinoClick(provider.platform, sections[activeIndex].type, sections[activeIndex].title )} >
                                                            <img
                                                                src={`${process.env.REACT_APP_API_URL}/provider/${provider.platform}.png`}
                                                                alt={provider.name || provider.platform}
                                                                className="ng-star-inserted"
                                                                onError={(e) => { e.target.src = './icons/platform/' + provider.platform + '.png'; }}
                                                            />
                                                            <p>{provider.platform}</p>
                                                        </a>
                                                    </li>
                                                ))
                                            ) : (
                                                <p></p>
                                            )}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* new function to handle blocked modal */}
            {showBlockedModal && (
            <div className="cdk-overlay-container">
                <div className="cdk-overlay-backdrop dialog-backdrop cdk-overlay-backdrop-showing" />
                <div className="cdk-global-overlay-wrapper" dir="ltr" style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <div id="cdk-overlay-2" className="cdk-overlay-pane dialog-panel" style={{ position: 'static' }}>
                    <div className="popup" id="dialog-2">
                        <div className="popup__header"></div>
                        <div className="popup__content">
                        <div className="pop-wrap promotion-pop new ng-trigger ng-trigger-popWrapTriggerAni ani show ">
                            <a className="btn-close" onClick={() => setShowBlockedModal(false)}>
                            <span className="item-icon" style={{ backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-cross-type01.svg?v=1743412106882")' }} />
                            </a>

                            <div className="pop-title">
                            <h3>【Market Block】</h3>
                            </div>
                            <div className="pop-inner content-style">
                            <div>
                                <p>
                                Dear customer,<br />
                                Your selected section "{blockedSection}" is currently blocked by Your Upline.
                                </p>
                                <p>Please Contact Customer Support for further assistance.</p>
                                <p>Thank you for your understanding.</p>
                            </div>
                            </div>
                        </div>

                        <div className="pop-bg" style={{ display: 'block' }} />
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        )}
   
  
        </div>
    );
};

export default GameNavIcon;
